import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | done | error

  useEffect(() => {
    if (!email || !token) {
      setStatus("error");
      return;
    }
    api.post("/newsletter/unsubscribe", { email, token })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [email, token]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-20" data-testid="unsubscribe-page">
      <Seo title="Unsubscribe - Zebaa" noindex />
      <div className="w-full max-w-md text-center bg-white border border-gray-100 shadow-sm p-10">
        {status === "loading" && (
          <>
            <Loader2 className="w-12 h-12 text-metallic-gold mx-auto animate-spin" data-testid="unsubscribe-loading" />
            <p className="text-gray-500 mt-5">Processing your request...</p>
          </>
        )}

        {status === "done" && (
          <div data-testid="unsubscribe-success">
            <CheckCircle2 className="w-14 h-14 text-metallic-gold mx-auto" />
            <h1 className="font-serif text-3xl text-charcoal mt-5">You've been unsubscribed</h1>
            <p className="text-gray-500 mt-3 leading-relaxed">
              {email ? <span className="text-charcoal font-medium">{email}</span> : "Your email"} will no longer
              receive marketing or offer emails from Zebaa. We're sorry to see you go.
            </p>
            <Link to="/" data-testid="unsubscribe-home" className="inline-block mt-7 bg-pink text-white px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors">
              Back to Home
            </Link>
          </div>
        )}

        {status === "error" && (
          <div data-testid="unsubscribe-error">
            <XCircle className="w-14 h-14 text-gray-300 mx-auto" />
            <h1 className="font-serif text-3xl text-charcoal mt-5">Link not valid</h1>
            <p className="text-gray-500 mt-3 leading-relaxed">
              This unsubscribe link is invalid or has expired. If you'd like to stop receiving emails,
              please contact us at hello@zebaa.uk.
            </p>
            <Link to="/contact" className="inline-block mt-7 border border-charcoal text-charcoal px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-charcoal hover:text-white transition-colors">
              Contact Us
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
